import React from 'react'
import ReduxContainer from '../../reduxContainer/ReduxContainer'
import UserLoadWrapper from '../../reduxContainer/UserLoadWrapper'
import ShowPageContent from './ShowPageContent'
import camelize from 'camelize'
import PropTypes from 'prop-types'

class Show extends React.Component {
  render () {
    return (
      <ReduxContainer>
        <UserLoadWrapper>
          <ShowPageContent
            {...this.props}
            playlist={camelize(JSON.parse(this.props.playlist))}
          />
        </UserLoadWrapper>
      </ReduxContainer>
    )
  }
}

Show.propTypes = {
  playlist: PropTypes.string,
  signedIn: PropTypes.bool,
  userIsAuthor: PropTypes.bool,
  userIsAdmin: PropTypes.bool
}

export default Show
